<i class="fa-solid fa-check"  *ngIf="params.value == '1'"></i>
